import React, { useState, useEffect } from "react";
import { GatsbyImage, StaticImage } from "gatsby-plugin-image";
import { Spotify, Cross } from "../svg";
import { useSpring, animated, useTransition, config } from "react-spring";
import artist from "../../studio/schemas/artist";

/* Artist Banner
============================================================================= */

const ArtistBanner = ({
	image,
	spotify = "1dIdBZaaHRW2bDTkHNfWln",
	artist,
}) => {
	const [flipped, set] = useState(false);
	const { transform, opacity } = useSpring({
		opacity: flipped ? 1 : 0,
		transform: `perspective(1400px) rotateX(${flipped ? 180 : 0}deg)`,
		config: { mass: 5, tension: 500, friction: 80 },
	});
	return (
		<div className="artist-banner-container">
			<animated.div
				className="c artist-banner-front"
				style={{
					opacity: opacity.interpolate((o) => 1 - o),
					transform,
				}}
			>
				<GatsbyImage
					className="artist-banner-image"
					style={{
						position: "absolute",
						top: 0,
						left: 0,
					}}
					alt={artist.name}
					objectFit="cover"
					objectPosition="50% 50%"
					image={image}
				/>
				<div className="absolute bottom-0 w-full pointer-events-auto h-[80px]">
					<iframe
						src={`https://open.spotify.com/embed/artist/${spotify}`}
						width="100%"
						height="80"
						frameborder="0"
						allowtransparency="true"
						allow="encrypted-media"
						style={{
							zIndex: 10000,
						}}
					></iframe>
				</div>
				{/* <div
					onClick={() => set((state) => !state)}
					style={{ pointerEvents: flipped ? "none" : "auto" }}
				>
					<Spotify className="spotify-artist-banner" fill="white" />
				</div> */}
			</animated.div>
			{/* <animated.div
				className="c artist-banner-back"
				style={{
					opacity,

					transform: transform.interpolate(
						(t) => `${t} rotateX(180deg)`
					),
				}}
			>
				<div
					onClick={() => set((state) => !state)}
					style={{ pointerEvents: flipped ? "auto" : "none" }}
				>
					<iframe
						className="artist-banner-spotify-iframe"
						src={`https://open.spotify.com/embed/artist/${spotify}`}
						width="100%"
						frameborder="0"
						allowtransparency="true"
						allow="encrypted-media"
					></iframe>
					<Cross />
				</div>
			</animated.div> */}
		</div>
	);
};

/* Export
============================================================================= */

export default ArtistBanner;
